<script>
  import { onMount } from 'svelte';
  import { format } from 'svelte-i18n';

  import { Icon } from '@client/components/icon';

  export let isOpen = false;
  export let maxHeight = 0;

  let element;

  const toggle = () => {
    isOpen = !isOpen;
    maxHeight = isOpen ? element.scrollHeight : 0;
  };

  onMount(() => {
    maxHeight = isOpen ? element.scrollHeight : 0;
  });
</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<div role="button" tabindex={-1} on:click={() => toggle()}>
  <slot name="toggle" {isOpen}>
    <h6>
      {#if isOpen}
        {$format('label.LESS')} <Icon name="chevron-up" />
      {:else}
        {$format('label.MORE')} <Icon name="chevron-down" />
      {/if}
    </h6>
  </slot>
</div>

<div class="collapsible" style:max-height="{maxHeight}px" bind:this={element}>
  <slot />
</div>

<style>
  .collapsible {
    overflow: hidden;
    transition: max-height 0.35s ease;
  }

  h6 {
    color: var(--color-gray-500);
  }
</style>
